import React from 'react';
import {
  Edit,
  ReferenceField,
  SaveButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  required,
} from 'react-admin';

const HrisLocationMappingEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <>
      <SimpleShowLayout>
        <ReferenceField label="Company" source="company_id" reference="Company" link="show">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Location" source="location_id" reference="Location" link="show">
          <TextField source="name" />
        </ReferenceField>
      </SimpleShowLayout>
      <SimpleForm
        toolbar={
          <Toolbar>
            <SaveButton />
          </Toolbar>
        }
      >
        <TextInput label="External ID" source="external_id" validate={[required()]} />
      </SimpleForm>
    </>
  </Edit>
);

export default HrisLocationMappingEdit;
